import {
  TbActivity,
  TbAlertCircle,
  TbAlertOctagon,
  TbAlertTriangle,
  TbAlignCenter,
  TbAlignLeft,
  TbAlignRight,
  TbArchive,
  TbArrowDownRight,
  TbArrowLeft,
  TbArrowRight,
  TbArrowUpRight,
  TbAward,
  TbBath,
  TbBed,
  TbBell,
  TbBellOff,
  TbBold,
  TbBox,
  TbBrandFacebook,
  TbBrandInstagram,
  TbBrandLinkedin,
  TbBriefcase,
  TbCalendar,
  TbCamera,
  TbCar,
  TbChartBar,
  TbChartPie,
  TbCheck,
  TbChevronDown,
  TbChevronLeft,
  TbChevronRight,
  TbChevronUp,
  TbCircle,
  TbCircleCheck,
  TbCircleX,
  TbClipboard,
  TbClock,
  TbCode,
  TbColumns,
  TbCopy,
  TbCornerUpLeft,
  TbCornerUpRight,
  TbCpu,
  TbCreditCard,
  TbCurrencyDollar,
  TbDatabase,
  TbDeviceDesktop,
  TbDeviceMobile,
  TbDeviceTablet,
  TbDownload,
  TbEdit,
  TbExternalLink,
  TbEye,
  TbEyeOff,
  TbFile,
  TbFileText,
  TbFilter,
  TbFlag,
  TbFolder,
  TbFolderPlus,
  TbGitBranch,
  TbGitMerge,
  TbGlobe,
  TbGridDots,
  TbGripVertical,
  TbHash,
  TbHeadphones,
  TbHeart,
  TbHelp,
  TbHome,
  TbInbox,
  TbInfoCircle,
  TbItalic,
  TbKey,
  TbStack,
  TbLink,
  TbList,
  TbListNumbers,
  TbLoader,
  TbLock,
  TbLockOpen,
  TbLogout,
  TbMail,
  TbMapPin,
  TbMaximize,
  TbMenu2,
  TbLayoutSidebar,
  TbMessage,
  TbMessageCircle,
  TbMicrophone,
  TbMinimize,
  TbMinus,
  TbMoodSmile,
  TbMoon,
  TbMusic,
  TbPackage,
  TbPaperclip,
  TbPercentage,
  TbPhone,
  TbPhoto,
  TbPlayerPause,
  TbPlayerPlay,
  TbPlayerSkipForward,
  TbPlayerStop,
  TbPlus,
  TbPointer,
  TbPower,
  TbQrcode,
  TbRefresh,
  TbRepeat,
  TbRotate,
  TbRotateClockwise,
  TbRuler,
  TbSearch,
  TbSend,
  TbServer,
  TbSettings,
  TbShare,
  TbShield,
  TbShoppingBag,
  TbSlash,
  TbSpeakerphone,
  TbAdjustments,
  TbSquare,
  TbSquareCheck,
  TbStar,
  TbStrikethrough,
  TbSun,
  TbTag,
  TbTarget,
  TbTemperature,
  TbFlame,
  TbBrandYoutube,
  TbToggleLeft,
  TbToggleRight,
  TbTool,
  TbTrash,
  TbTrendingDown,
  TbTrendingUp,
  TbTruck,
  TbTypography,
  TbUnderline,
  TbUpload,
  TbUser,
  TbUserCheck,
  TbUserPlus,
  TbUsers,
  TbVideo,
  TbWifi,
  TbWifiOff,
  TbX,
  TbBolt,
  TbZoomIn,
  TbZoomOut,
  TbDotsVertical,
  TbDots,
  TbArrowsShuffle,
  TbDeviceFloppy,
} from 'react-icons/tb'

import type { IconPack } from '../types'

export const tablerPack: IconPack = {
  // Navigation
  'home': TbHome,
  'menu': TbMenu2,
  'panel-left': TbLayoutSidebar,
  'chevron-down': TbChevronDown,
  'chevron-left': TbChevronLeft,
  'chevron-right': TbChevronRight,
  'chevron-up': TbChevronUp,
  'arrow-left': TbArrowLeft,
  'arrow-right': TbArrowRight,
  'arrow-up-right': TbArrowUpRight,
  'arrow-down-right': TbArrowDownRight,
  'corner-up-left': TbCornerUpLeft,
  'corner-up-right': TbCornerUpRight,
  'external-link': TbExternalLink,
  'log-out': TbLogout,
  'globe': TbGlobe,
  'map-pin': TbMapPin,

  // Actions
  'plus': TbPlus,
  'minus': TbMinus,
  'x': TbX,
  'check': TbCheck,
  'check-circle': TbCircleCheck,
  'check-square': TbSquareCheck,
  'x-circle': TbCircleX,
  'search': TbSearch,
  'zoom-in': TbZoomIn,
  'zoom-out': TbZoomOut,
  'filter': TbFilter,
  'refresh': TbRefresh,
  'rotate-ccw': TbRotate,
  'rotate-cw': TbRotateClockwise,
  'repeat': TbRepeat,
  'shuffle': TbArrowsShuffle,
  'download': TbDownload,
  'upload': TbUpload,
  'share': TbShare,
  'copy': TbCopy,
  'save': TbDeviceFloppy,
  'edit': TbEdit,
  'trash': TbTrash,
  'archive': TbArchive,
  'send': TbSend,
  'drag': TbGripVertical,
  'maximize': TbMaximize,
  'minimize': TbMinimize,
  'mouse-pointer': TbPointer,
  'power': TbPower,

  // Communication
  'mail': TbMail,
  'inbox': TbInbox,
  'message-circle': TbMessageCircle,
  'message-square': TbMessage,
  'phone': TbPhone,
  'video': TbVideo,
  'mic': TbMicrophone,
  'headphones': TbHeadphones,
  'bell': TbBell,
  'bell-off': TbBellOff,

  // Media & Content
  'image': TbPhoto,
  'camera': TbCamera,
  'file': TbFile,
  'file-text': TbFileText,
  'folder': TbFolder,
  'folder-plus': TbFolderPlus,
  'paperclip': TbPaperclip,
  'link': TbLink,
  'music': TbMusic,
  'play': TbPlayerPlay,
  'pause': TbPlayerPause,
  'pause-circle': TbPlayerPause,
  'stop-circle': TbPlayerStop,
  'skip-forward': TbPlayerSkipForward,

  // Data & Analytics
  'bar-chart': TbChartBar,
  'pie-chart': TbChartPie,
  'trending-up': TbTrendingUp,
  'trending-down': TbTrendingDown,
  'activity': TbActivity,
  'award': TbAward,
  'megaphone': TbSpeakerphone,
  'percent': TbPercentage,
  'target': TbTarget,
  'database': TbDatabase,
  'grid': TbGridDots,
  'columns': TbColumns,
  'list': TbList,
  'list-ordered': TbListNumbers,
  'hash': TbHash,
  'layers': TbStack,
  'sliders': TbAdjustments,

  // Users & People
  'user': TbUser,
  'user-plus': TbUserPlus,
  'user-check': TbUserCheck,
  'users': TbUsers,
  'smile': TbMoodSmile,

  // Business & Commerce
  'bed': TbBed,
  'car': TbCar,
  'briefcase': TbBriefcase,
  'shopping-bag': TbShoppingBag,
  'credit-card': TbCreditCard,
  'dollar-sign': TbCurrencyDollar,
  'tag': TbTag,
  'package': TbPackage,
  'truck': TbTruck,
  'box': TbBox,

  // Security & Status
  'lock': TbLock,
  'unlock': TbLockOpen,
  'slash': TbSlash,
  'key': TbKey,
  'shield': TbShield,
  'eye': TbEye,
  'eye-off': TbEyeOff,
  'alert-circle': TbAlertCircle,
  'alert-octagon': TbAlertOctagon,
  'alert-triangle': TbAlertTriangle,
  'info': TbInfoCircle,
  'help-circle': TbHelp,
  'flag': TbFlag,
  'circle': TbCircle,
  'square': TbSquare,

  // Settings & Tools
  'settings': TbSettings,
  'tool': TbTool,
  'code': TbCode,
  'cpu': TbCpu,
  'server': TbServer,
  'wifi': TbWifi,
  'wifi-off': TbWifiOff,
  'smartphone': TbDeviceMobile,
  'qr-code': TbQrcode,
  'tablet': TbDeviceTablet,
  'thermometer': TbTemperature,
  'flame': TbFlame,
  'youtube': TbBrandYoutube,
  'toggle-left': TbToggleLeft,
  'toggle-right': TbToggleRight,
  'loader': TbLoader,
  'calendar': TbCalendar,
  'clock': TbClock,

  // Appearance
  'sun': TbSun,
  'moon': TbMoon,
  'heart': TbHeart,
  'star': TbStar,
  'zap': TbBolt,

  // Text Formatting
  'bold': TbBold,
  'italic': TbItalic,
  'underline': TbUnderline,
  'strikethrough': TbStrikethrough,
  'type': TbTypography,
  'align-left': TbAlignLeft,
  'align-center': TbAlignCenter,
  'align-right': TbAlignRight,

  // Version Control
  'git-branch': TbGitBranch,
  'git-merge': TbGitMerge,

  // Social / Brand
  'facebook': TbBrandFacebook,
  'instagram': TbBrandInstagram,
  'linkedin': TbBrandLinkedin,
  'monitor': TbDeviceDesktop,

  // Specialty
  'bath': TbBath,
  'ruler': TbRuler,
  'clipboard': TbClipboard,
  'more-horizontal': TbDots,
  'more-vertical': TbDotsVertical,
}
